import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FileTextIcon, BookIcon, PlayCircleIcon } from '../assets/icons/Icons';
import '../styles/resources.css';

const resourcesData = [
  {
    icon: <FileTextIcon size={20} />,
    title: 'Self-assessment',
    desc: 'PHQ-9, GAD-7, and other validated screening tools to understand where you are.',
    cardClass: 'assess',
    link: '/resources/self-assessment',
  },
  {
    icon: <BookIcon size={20} />,
    title: 'Articles & guides',
    desc: 'Expert-written content on managing stress, building resilience, and understanding mental health.',
    cardClass: 'articles',
    link: '/resources/articles',
  },
  {
    icon: <PlayCircleIcon size={20} />,
    title: 'Worksheets & trackers',
    desc: 'Journaling, breathing techniques, and grounding exercises — private to your device, downloadable any time.',
    cardClass: 'guided',
    link: '/resources/journal',
  },
];

const Resources = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-up');
    elements?.forEach((el) => observer.observe(el));
    return () => elements?.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <section className="resources-section" id="resources" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-up">
          <span className="section-tag">Resources</span>
          <h2>Tools for your journey</h2>
          <p>Free resources to support your mental wellbeing every day</p>
        </div>

        <div className="resources-bento fade-up">
          {resourcesData.map((item, i) => {
            const inner = (
              <>
                <div className="resource-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </>
            );
            return item.link ? (
              <Link
                key={i}
                to={item.link}
                className={`resource-card ${item.cardClass}`}
              >
                {inner}
              </Link>
            ) : (
              <div key={i} className={`resource-card ${item.cardClass}`}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Resources;
